import { render } from "./template.html?vue&type=template&id=b54e3f88&scoped=true"
import script from "./script.js?vue&type=script&lang=js"
export * from "./script.js?vue&type=script&lang=js"

import "./style.css?vue&type=style&index=0&id=b54e3f88&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b54e3f88"]])

export default __exports__